import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import RefreshAds from './RefreshAds';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import safelyEvalAdScript from './safelyEvalAdScript';
import areAdsBypassed from './areAdsBypassed';
import isDevelopment from './isDevelopment';
export default function InsertDiscussionSidebarAd() {
  const root = document.querySelector(':root');
  const AdCode = app.data['nagusi-ext-ads.ad-code.discussion_sidebar'];
  const Script = app.data['nagusi-ext-ads.ad-code.discussion_sidebar.js'];
  const dev = isDevelopment();
  const Html = dev ? m("p", null, "Anuncio") : m.trust(AdCode);
  root.style.setProperty('--nagusi-ext-ads--discussion-sidebar-position', '36px');
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    if (areAdsBypassed()) return;

    // Only show sidebar ad on desktop and tablet
    if (['desktop-hd', 'desktop', 'tablet'].includes(getComputedStyle(root).getPropertyValue('--flarum-screen'))) {
      items.add('nagusi-ext-ads', m("div", {
        class: "nagusi-ad nagusi-ad-discussion-sidebar"
      }, Html), 1000);
    }
  });
  extend(DiscussionPage.prototype, ['oncreate', 'onupdate'], function (returned) {
    if (areAdsBypassed() || dev) return;
    RefreshAds();
    safelyEvalAdScript('discussion sidebar', Script);
  });
}